// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"022cc752","455":"235879f7","977":"14a8496b"}[chunkId] + ".chunk.js";
};